import { Stack } from '@moda/om';
import React from 'react';
import { CarouselPumoModuleFragment } from '../../../generated/types';
import { TrunkshowPageSubtitle } from '../../TrunkshowPageSubtitle';
import { EnhancedLooksModuleContent } from '../EnhancedLooksModuleContent';

interface Props {
  carousel: CarouselPumoModuleFragment;
}

export const SingleLooksModule: React.FC<Props> = ({ carousel }) => {
  if (carousel.cells.length === 0) return null;

  return (
    <Stack space={6}>
      <TrunkshowPageSubtitle>Shop Looks</TrunkshowPageSubtitle>

      <EnhancedLooksModuleContent carousel={carousel} />
    </Stack>
  );
};
